// MaestroDeZonas.jsx
import React, { useState, useEffect, useCallback } from 'react';
import ZoneModule from './partes/ZoneModule';
import { getClientsZones, getOptionsExecutives, getOptionsLeaders, getUsersInCharge, getUnitsZones, updateClient, getZonesOption, updateUnit } from './integracion';

import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button'; // Asegúrate de importar Button si lo usas en el errorData

import './MaestroDeZonas.scss';

export default function MaestroDeZonas() {
    const [allZonesUsers, setAllZonesUsers] = useState(null);
    const [loadingData, setLoadingData] = useState(true);
    const [errorData, setErrorData] = useState(null);

    const [leadersOptions, setLeadersOptions] = useState([]);
    const [executivesOptions, setExecutivesOptions] = useState([]);
    const [zonesOptions, setZonesOptions] = useState([]);

    const [allClientsData, setAllClientsData] = useState([]);
    const [allUnitsData, setAllUnitsData] = useState([]);

    // Función de recarga centralizada para todos los datos de la API
    // ¡CORRECCIÓN CLAVE AQUÍ: Dependencias vacías para useCallback!
    const fetchAllData = useCallback(async () => {
        // Solo mostramos el spinner de carga inicial si aún no tenemos ningún dato
        if (!allZonesUsers) {
            setLoadingData(true);
        }
        setErrorData(null);
        try {
            // Se asume que getUsersInCharge, getOptionsLeaders, etc., actualizan sus respectivos estados
            await getUsersInCharge(setAllZonesUsers);
            await getClientsZones(setAllClientsData);
            await getUnitsZones(setAllUnitsData);
        } catch (err) {
            console.error("Error al cargar datos en MaestroDeZonas:", err);
            setErrorData(err.message || "Error desconocido al cargar datos.");
        } finally {
            setLoadingData(false);
        }
    }, []);

    // Efecto principal para cargar TODOS los datos necesarios al montar
    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]); // fetchAllData ahora es una dependencia estable gracias a useCallback([])
    useEffect(() => {
        const getOptions = async () => {
            await getOptionsLeaders(setLeadersOptions);
            await getOptionsExecutives(setExecutivesOptions);
            await getZonesOption(setZonesOptions);
        }
        getOptions()
    }, [])
    // Handler para reasignación de clientes/unidades
    const handleReassignItem = async (item, type, oldZoneName, newZoneValue) => {
        console.log(`Global Reassign: ${type} ${item.ID_CLIENTE || item.ID} from ${oldZoneName} to ${newZoneValue}`);
        if (type == 'client') {
            const params = {
                id_client: item.ID_CLIENTE,
                new_zone: newZoneValue
            }
            updateClient(params)
        }
        else {
            const params = {
                id_unit: item.ID,
                new_zone: newZoneValue
            }
            updateUnit(params)
        }
        await fetchAllData();
    };

    // Handler para actualizar líder/ejecutivo (llamado desde ZoneModule)
    const handleLeaderExecutiveUpdate = async () => {
        console.log("Se ha notificado una actualización de líder/ejecutivo. Refrescando todos los datos.");
        await fetchAllData();
    };

    // Muestra un spinner de carga a pantalla completa solo en la carga inicial
    if (loadingData && !allZonesUsers) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw' }}>
                <ProgressSpinner style={{ width: '80px', height: '80px' }} strokeWidth="5" animationDuration=".8s" />
            </div>
        );
    }

    // Muestra un mensaje de error si ocurre uno grave
    if (errorData) {
        return (
            <div className="p-message p-message-error p-m-3" style={{ textAlign: 'center' }}>
                <h3>Error al cargar datos</h3>
                <p>{errorData}</p>
                <Button label="Reintentar" icon="pi pi-refresh" onClick={fetchAllData} className="p-mt-2" />
            </div>
        );
    }

    const zoneNames = allZonesUsers ? Object.keys(allZonesUsers) : [];

    return (
        <div className="app-container">
            <section className="zones-grid">
                {zoneNames.length > 0 ? (
                    zoneNames.map(zoneName => {
                        const zoneData = allZonesUsers[zoneName];
                        
                        return (
                            <ZoneModule
                                key={zoneName}
                                zoneName={zoneName}
                                zoneData={zoneData}
                                leadersOptions={leadersOptions}
                                executivesOptions={executivesOptions}
                                clientsInZone={allClientsData.filter(c => c.ZONA === zoneName)}
                                unitsInZone={allUnitsData.filter(u => u.ZONA === zoneName)}
                                onReassignItem={handleReassignItem}
                                onLeaderExecutiveUpdate={handleLeaderExecutiveUpdate}
                                zonesOptions={zonesOptions}
                                // zoneDescription = {}
                            />
                        );
                    })
                ) : (
                    // Si no hay zonas después de la carga (y no hay error)
                    <div>No se encontraron zonas operativas para mostrar.</div>
                )}
            </section>
        </div>
    );
}